module.exports = __webpack_public_path__ + "static/img/tijian.2775c3a9.png";